/** biome-ignore-all assist/source/useSortedAttributes: <more readable> */

import { lazyImport } from "@resamare/ui";
import { Navigate, Route, Routes } from "react-router-dom";
import DefaultLayout from "@/components/Layout/DefaultLayout";

const { SessionsPage } = lazyImport(() => import("../pages"), "SessionsPage");
const { SessionDetailsPage } = lazyImport(() => import("../pages"), "SessionDetailsPage");

export function SessionsRoutes() {
    return (
        <Routes>
            <Route element={<DefaultLayout />}>
                <Route path="/" element={<SessionsPage />} />
                <Route path="/:sessionId" element={<SessionDetailsPage />} />
                <Route path="*" element={<Navigate to="." />} />
            </Route>
        </Routes>
    );
}
